import { EmailAddress } from '@constants';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import feedbackSuccess from '@assets/ra_feedback_success.svg';
import classes from './Feedback.module.css';

const FEEDBACK_TEXT = {
  title: 'Congrats! You are all set',
  desc: 'Your application has been submitted. The result will be sent by email in 2 working days. Should you have any questions, please feel free to ',
};

export default function Feedback() {
  return (
    <div className={classes.feedback}>
      <div className={classes.content}>
        <img src={feedbackSuccess} alt="" className={classes.img} />
        <div className={classes.title}>{FEEDBACK_TEXT.title}</div>
        <div className={classes.desc}>
          {FEEDBACK_TEXT.desc}
          <a
            href={`mailto:${EmailAddress.Seel}`}
            className={classes.contact_support}
          >
            contact our support.

          </a>
        </div>
        <Link to="/">
          <Button>Back to home</Button>
        </Link>
      </div>
    </div>
  );
}
